module.exports = __webpack_public_path__ + "img/image-11.d3851c19.jpg";